/**
 * Central analytics utilities for tracking user interactions
 * Provides consistent event publishing and data structure
 */

/**
 * Publishes analytics events with consistent data structure
 * @param {string} eventName - The event name in snake_case
 * @param {Object} data - Event data object
 */
export function publishAnalyticsEvent(eventName, data = {}) {
    try {
        Shopify.analytics.publish(eventName, data);

        // Log in development
        if (window.themeVariables?.settings?.debug) {
            console.log(`[Analytics] ${eventName}:`, data);
        }
    } catch (error) {
        console.error('Failed to publish analytics event:', error);
    }
}

/**
 * Tracks when comparison section is viewed on PDP
 * @param {Object} data - Event data
 */
export function trackComparisonSectionViewed(data = {}) {
    publishAnalyticsEvent('viewed_comparison_section_pdp', data);
}

/**
 * Tracks when user adds to cart from comparison context
 * @param {Object} data - Event data
 */
export function trackAddToCartFromComparison(data = {}) {
    publishAnalyticsEvent('added_to_cart_from_comparison', data);
}

/**
 * Tracks when user adds additional products during customization
 * @param {Object} data - Event data
 */
export function trackAdditionalProductsCustomization(data = {}) {
    publishAnalyticsEvent('added_additional_products_customization', data);
}

/**
 * Tracks when quiz is opened (detected via URL parameter)
 * @param {Object} data - Event data
 */
export function trackQuizOpened(data = {}) {
    publishAnalyticsEvent('opened_quiz', data);
}

/**
 * Tracks when menu is opened
 * @param {Object} data - Event data
 */
export function trackMenuOpened(data = {}) {
    publishAnalyticsEvent('opened_menu', data);
}

/**
 * Initializes URL-based tracking (like quiz detection)
 */
export function initUrlBasedTracking() {
    // Track quiz opening if parameter is present
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('aidenSidebar')) {
        trackQuizOpened();
    }

    // Listen for URL changes (for SPAs or dynamic parameter changes)
    let currentUrl = window.location.href;
    setInterval(() => {
        if (window.location.href !== currentUrl) {
            currentUrl = window.location.href;
            const newParams = new URLSearchParams(window.location.search);
            if (newParams.has('aidenSidebar')) {
                trackQuizOpened();
            }
        }
    }, 1000);
}
